//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
let d=[[[1,"MinimumCutLength",0,"CAM.InheritableDoubleBuilder",0],[1,"OverlapDistance",0,"CAM.InheritableDoubleBuilder",0],[0,"SplitType",1,0],[0,"TransferHeight",1,0],[1,"TransferHeightBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"TransferType",1,0],[0,"TransferUsingMethod",1,0],[0,"TrimmingSteepAngle",1,0],[0,"UseGlobalClearance",1,0]],[],[]];
SPLM.CAM.ToolPathSplitParametersBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ToolPathSplitParametersBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.ToolPathSplitParametersBuilder.SplitTypes = Object.freeze({
    "ByCollision" : "ByCollision", "ByTransfer" : "ByTransfer"});

SPLM.CAM.ToolPathSplitParametersBuilder.TransferUsingMethods = Object.freeze({
    "None" : "None", "RampOnShape" : "RampOnShape", "LiftAndPlunge" : "LiftAndPlunge"});

SPLM.CAM.ToolPathSplitParametersBuilder.TransferTypes = Object.freeze({
    "Direct" : "Direct", "Clearance" : "Clearance", "LowestSafeZ" : "LowestSafeZ", "Smooth" : "Smooth", "Plane" : "Plane"});

export default SPLM;